<div class="product-view large-page">
  <div class="container">
    <div *ngIf="produktblatt$ | async as sheet" class="row custom-row">
      <div class="col-md-8">
        <div class="row">
          <div class="form-container col-md-6">
            <app-collapsible [trackBy]="sheet.product.id">
              <div class="produkt-headline headline-text">{{ sheet.product.name }}</div>
              <div class="produkt-claim headline-text">{{ sheet.product.claim }}</div>
              <div class="basic-text description d-print-none">{{ sheet.product.description }}</div>
            </app-collapsible>

            <!-- Show first image in print view only -->
            <div *ngIf="mainImage$ | async as mainImage" class="d-none d-print-block">
              <div class="justify-content-center">
                <img class="print-image" [src]="mainImage.url" alt="" />
              </div>
            </div>

            <div class="basic-text description d-none d-print-block">{{ sheet.product.description }}</div>

            <table class="product-properties basic-text">
              <tr>
                <td>Gründungsjahr:</td>
                <td>{{ sheet.startup.founded }}</td>
              </tr>
              <tr>
                <td>Warenbereich:</td>
                <td>{{ productGroupViewValue(sheet.product.productGroup) }}</td>
              </tr>
              <tr>
                <td>UVP:</td>
                <td>{{ sheet.product.uvp | uvp }} &euro;</td>
              </tr>
              <tr>
                <td>VPE:</td>
                <td>{{ sheet.product.packingUnit }}</td>
              </tr>
              <tr>
                <td>Gelistet bei:</td>
                <td>{{ sheet.product.listed }}</td>
              </tr>
              <tr>
                <td colspan="2" class="documents" *ngIf="sheet.product.documents.length > 0">
                  Dokumente:
                  <div *ngFor="let document of sheet.product.documents" class="file">
                    <a [attr.href]="document.uri" target="_blank">
                      <i class="far fa-file-pdf"></i>&nbsp;
                      {{ shortenName(document.displayName) }}
                      <markant-tooltip
                        *ngIf="shortenName(document.displayName).length > 32"
                        [label]="document.displayName"
                        placement="top"
                        trigger="mouseenter focus"
                        colorScheme="secondary"
                      ></markant-tooltip>
                    </a>
                  </div>
                </td>
              </tr>
              <tr *ngIf="sheet.product.pitchDeck as pitchDeck">
                <td colspan="2" class="pitch-deck">
                  Pitch Deck
                  <div class="file">
                    <a class="basic-text file" style="text-align: left" [attr.href]="pitchDeck.uri" target="_blank">
                      <i class="far fa-file-pdf"></i>&nbsp;
                      {{ shortenName(pitchDeck.displayName) }}
                      <markant-tooltip
                        *ngIf="shortenName(pitchDeck.displayName).length > 32"
                        [label]="pitchDeck.displayName"
                        placement="top"
                        trigger="mouseenter focus"
                        colorScheme="secondary"
                      ></markant-tooltip>
                    </a>
                  </div>
                </td>
              </tr>
            </table>
          </div>

          <div class="col-md-6 center-stuff d-print-none">
            <img *ngIf="sheet.startup.logo?.uri; else noLogo" width="300" height="300" style="margin-bottom: 2em" src="{{ sheet.startup.logo?.uri }}" alt="" />
            <ng-template #noLogo>
              <div class="picture-placeholder">
                <span>Es wurde noch kein Firmenlogo hochgeladen.</span>
              </div>
            </ng-template>
            <img
              *ngIf="sheet.product.coverImage; else noCover"
              width="300"
              height="300"
              style="margin-bottom: 1em"
              src="{{ sheet.product.coverImage.uri }}"
              alt=""
            />
            <ng-template #noCover>
              <div class="picture-placeholder">
                <span>Es wurde noch kein Produktbild hochgeladen.</span>
              </div>
            </ng-template>
          </div>
        </div>
      </div>

      <div class="col-md-4 startupColumn">
        <app-collapsible [trackBy]="sheet.startup.uuid">
          <div class="startup-headline headline-text">
            {{ sheet.startup.nickname }}
          </div>
          <p class="u-full-width basic-text description d-print-none" id="startupDescription">{{ sheet.startup.description }}</p>
        </app-collapsible>

        <div class="u-full-width basic-text description d-none d-print-block">{{ sheet.startup.description }}</div>

        <address class="basic-text" style="margin-top: 2em">
          <span class="startup-nick">{{ sheet.startup.name }}</span
          ><br />
          {{ sheet.startup.street }}<br />
          {{ sheet.startup.zip }} {{ sheet.startup.city }}<br />
        </address>

        <div class="findUs">
          <div class="homepage">
            <a class="basic-text" target="_blank" [attr.href]="Startup.extractLink(LinkType.WEBSITE, sheet.startup.links) | linkHttp">{{
              Startup.extractLink(LinkType.WEBSITE, sheet.startup.links)
            }}</a>
          </div>

          <div class="d-print-none">
            <ng-container *ngIf="Startup.extractLink(LinkType.FACEBOOK, sheet.startup.links)">
              <a target="_blank" [attr.href]="Startup.extractLink(LinkType.FACEBOOK, sheet.startup.links) | linkHttp"
                ><img class="social-media-icon" src="./assets/img/icon/facebook.svg" alt=""
              /></a>
            </ng-container>
            <ng-container *ngIf="Startup.extractLink(LinkType.TWITTER, sheet.startup.links)">
              <a target="_blank" [attr.href]="Startup.extractLink(LinkType.TWITTER, sheet.startup.links) | linkHttp"
                ><img class="social-media-icon" src="./assets/img/icon/twitter.svg" alt=""
              /></a>
            </ng-container>
            <ng-container *ngIf="Startup.extractLink(LinkType.INSTAGRAM, sheet.startup.links)">
              <a target="_blank" [attr.href]="Startup.extractLink(LinkType.INSTAGRAM, sheet.startup.links) | linkHttp"
                ><img class="social-media-icon" src="./assets/img/icon/instagram.svg" alt=""
              /></a>
            </ng-container>
          </div>
        </div>

        <div class="contact basic-text">
          <div>
            <div class="name">
              {{ getContactName(sheet.startup) }}
            </div>
            <div>{{ sheet.startup.contact.phone }} <br /></div>
            <div>
              <a class="email" [href]="'mailto:' + sheet.startup.contact.email">{{ sheet.startup.contact.email }}</a>
            </div>
          </div>

          <ng-content select=".product-view-sub-contact"></ng-content>

          <div class="dates basic-text">
            <table style="width: 100%">
              <tr class="text-left-top">
                <th>registriert seit:</th>
                <td>{{ sheet.startup.created | moment: 'date' }}</td>
              </tr>
              <tr class="text-left-top">
                <th>zuletzt aktualisiert:</th>
                <td>{{ sheet.product.modified | moment: 'date' }}</td>
              </tr>
              <tr *ngIf="userService.currentUser().userType != userType.HP" class="text-left-top">
                <th>Bewerbung:</th>
                <td>
                  <div *ngFor="let application of applications$ | async">{{ application }}</div>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-print-none">
        <div class="row media-row">
          <div *ngIf="sheet.product.pitchVideo" class="col-md-6">
            <div class="subheadline-text">Pitch-Video</div>
            <div class="no-margin-on-xs">
              <video playsinline controls width="100%" [poster]="sheet.product.pitchVideo.uriPoster">
                <source [src]="sheet.product.pitchVideo.uriWebm" type="video/webm" />
                <source [src]="sheet.product.pitchVideo.uriMp4" type="video/mp4" />
              </video>
            </div>
          </div>
          <div [class]="sheet.product.pitchVideo ? 'col-md-6' : 'col-md-12'">
            <div *ngIf="(images$ | async)?.length" class="subheadline-text">Produktbilder</div>
            <app-media-list-published [images]="images$ | async" [fullPage]="true"></app-media-list-published>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
